import React, { Component, useState } from 'react';

import { Link } from "react-router-dom";

import { BrowserRouter } from 'react-router-dom';

import { CiMenuBurger } from 'react-icons/ci';
import LOGO from './../logo/logo.png';
import './style.css';

import Menu from './Menu';

export default function MobileMenu() {
   let [modalActive, setModalActive] = useState(false);
   return (
      <div className='nav_mobile--menu'>
         <Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} to={"/"} className='logo_align'><img src={LOGO} alt="Interno" /></Link>
         <button onClick={() => setModalActive(modalActive = !modalActive)} active={modalActive} setActive={setModalActive} className={`nav_menu--open ${modalActive && 'active'}`} >
            <div className="btn__menu" >
               <div className='center_line'></div>
            </div>
         </button>
         <Menu active={modalActive} setActive={setModalActive} ></Menu>
      </div >
   )
}
